import React, { useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import ButtonStartIcon from '../../../../button/ButtonStartIcon'
import InputField from '../../../../FormControl/input/InputField'
import Skeleton from '@mui/material/Skeleton';
import useCurriculums from '../../../../../hooks/curriculum/useCurriculum'
import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

const General = ({ data, isLoading }) => {
  const { curriculumId } = useParams()
  const permission = useSelector((state) => state?.session?.permissions?.curriculum?.updated)

  const [loading, toggleLoading] = useState(false);
  const [form, setForm] = useState({});
  const [error, setError] = useState({});
  
  const { 
    errors: errorsData,
    updateCurriculumBasicInformation,
  } = useCurriculums()

  const onSave = async (e) => {
    e.preventDefault()
    toggleLoading(true)
    try {
      let result = await updateCurriculumBasicInformation(curriculumId, form)
      if (result.error) {
        setError(result)
      } else {
        onClose()
      }
    } finally {
      toggleLoading(false)
    }
  }

  const onChange = (name, value) => {
    setForm({ ...form, [name]: value })
    setError({ ...error, [name]: '' })
  }

  useEffect(() => {
    setError(errorsData)
  }, [errorsData])

  useEffect(() => {
    if (data) {
      setForm(data)
    }
  }, [data])

  return (
    <>
      <Box className='bg-primary text-primary-foreground px-4 py-1 flex gap-4 items-center justify-between h-8'>
        <Typography variant='subtitle1' className='uppercase'>Basic information</Typography>
        { permission && 
          <ButtonStartIcon
            onClick={onSave}
            color='secondary'
            variant='contained'
            startIcon={["fas","save"]}
            loading={loading}
          >
            Save
          </ButtonStartIcon>
        }
      </Box>
      <Box className='px-4 pt-6 pb-4'>
        <Grid container spacing={2}>
          <Grid item md={2} sm={3}>
            <Typography variant='inherit'  color='primary'className='font-bold' align='right' component='p'>
              Name
            </Typography>
          </Grid>
          <Grid item md={9} sm={8}>
            { isLoading ?
              <Typography><Skeleton /></Typography> :
              permission 
              ? <InputField
                  id='curriculum-name'
                  name="name"
                  value={form.name}
                  error={error.name}
                  helperText={error.name}
                  disabled={loading}
                  onChange={(e) => onChange(e.target.name, e.target.value)}
              /> 
              : <Typography>{form?.name}</Typography>
            }
          </Grid>
          <Grid item md={2} sm={3}>
            <Typography variant='inherit'  color='primary'className='font-bold' align='right' component='p'>
              Short Name
            </Typography>
          </Grid>
          <Grid item md={9} sm={8}>
            { isLoading ?
              <Typography><Skeleton /></Typography> :
              permission 
              ? <InputField
                  id='curriculum-short-name'
                  name="shortName"
                  value={form.shortName}
                  error={error.shortName}
                  helperText={error.shortName}
                  disabled={loading}
                  onChange={(e) => onChange('shortName', e.target.value)}
              /> 
              : <Typography>{form?.shortName}</Typography>
            }
          </Grid>
        </Grid>
      </Box>
    </>

  )
}

export default General